import { render, staticRenderFns } from "./ModalSave.vue?vue&type=template&id=596740b2"
import script from "./ModalSave.vue?vue&type=script&lang=js"
export * from "./ModalSave.vue?vue&type=script&lang=js"
import style0 from "./ModalSave.vue?vue&type=style&index=0&id=596740b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports